<ng-container>
    <ng-content select="[label-prefix]"></ng-content>
    <form-control-label [question]="question" [id]="control.controlId" [flow]="flow"></form-control-label>
    <ng-content select="[lunaInput]" ></ng-content>
    <ng-content select="[label-suffix]"></ng-content>
</ng-container>